import {Modal} from "antd";
import React, {ReactNode, useEffect} from "react";
import {connect} from "react-redux";
import {useNavigate} from "react-router-dom";
import {bindActionCreators, Dispatch} from "redux";
import {setModalVisibility} from "../../../core/app/setModalVisibility/actions";
import {ModalType} from "../../../core/models/custom/enums/modalType";
import {ModalVisibilityPayload} from "../../../core/models/custom/modalVisibility.payload";
import {MeDto} from "../../../core/models/dtos/me.dto";
import {OfferDto} from "../../../core/models/dtos/offer.dto";
import FirebaseService from "../../../core/services/firebase.service";
import ContentKeys from "../../../core/utilities/contentKeys";
import {Images} from "../../../core/utilities/images";
import {IStore} from "../../../core/utilities/reducers";
import {router} from "../../../core/utilities/router";
import {LocalStorage} from "../../../core/utilities/storage";
import {UI} from "../../../core/utilities/ui";
import ContentKey from "../../ContentKey/ContentKey";
import ModalCancelButton from "../Common/ModalCancelButton/ModalCancelButton";
import ModalHeader from "../Common/ModalHeader/ModalHeader";
import Offers from "../Common/Offers/Offers";
import Reward from "../Common/Reward/Reward";
import "./CongratsModal.scss";

interface IProps {
  me?: MeDto;
  modalVisibilityData: ModalType[];
  setModalVisibility: (payload: ModalVisibilityPayload) => void;
  callback: (modal: ModalType, offer: OfferDto) => void;
}

const CongratsModal = (props: IProps) => {
  const navigate = useNavigate();
  const modal = ModalType.CONGRATS;
  
  useEffect(() => {
    LocalStorage.remove(LocalStorage.modalCongrats);
  }, []);
  
  const handleModal = (offer: OfferDto): void => {
    props.callback(modal, offer);
  }
  
  const handleModalClose = (): void => {
    FirebaseService.logEvent(FirebaseService.user_count_kmb_game_end_homepage_click);
    props.setModalVisibility({modal, isVisible: false});
    navigate(router.HOME);
  }
  
  const renderOffers = (): ReactNode => {
    return (
      <Offers
        offers={props.me?.offers ?? []}
        modal={modal}
        callbackSelection={offer => handleModal(offer)}
      />
    );
  }
  
  return (
    <Modal
      className="congrats-modal"
      maskStyle={UI.modalMaskStyle()}
      open
      closable={false}
      footer={false}
      centered
      destroyOnClose
      style={UI.getStyleModalOffer(props.modalVisibilityData)}
    >
      <ModalHeader
        className="congrats-modal"
        text={<ContentKey contentKey={ContentKeys.FINISH_GAME_HEADER}/>}
        icon={<img className="icon" src={Images.popup_header_icon_congrats} alt="icon"/>}
      />
      
      <div className="body">
        
        <Reward rewardKey={ContentKeys.getRewardKey(modal)}/>
        
        <ContentKey
          className="title link-medium"
          contentKey={ContentKeys.FINISH_GAME_TITLE}
        />
        
        <ContentKey
          className="text text-medium"
          contentKey={ContentKeys.FINISH_GAME_DESC}
        />
        
        {renderOffers()}
      </div>
      <ModalCancelButton callback={() => handleModalClose()}/>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      setModalVisibility,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
    modalVisibilityData: store.setModalVisibility.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CongratsModal);
